export default __webpack_public_path__ + "static/dvUmCjBE-0acb773945445b98a116e11ec429c0fa.svg";